export const getBackendUrl = () => {
  const ip = (process.env.REACT_APP_BACKEND_IP || "").trim().replace(/\/+$/, "");
  const port = (process.env.REACT_APP_BACKEND_PORT || "").trim();
  const ext = (process.env.REACT_APP_BACKEND_EXTENSION || "/api/website/enquiry/").trim();

  const formattedExt = ext.startsWith("/") ? ext : `/${ext}`;
  const finalExt = formattedExt.endsWith("/") ? formattedExt : `${formattedExt}/`;

  if (!ip) {
    return finalExt;
  }

  const portPart = port ? `:${port}` : "";
  return `${ip}${portPart}${finalExt}`;
};

export const backendUrl = getBackendUrl();
export default backendUrl;
